import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatRipple } from '@angular/material/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-gdpr-panel',
    templateUrl: './gdpr-panel.component.html',
    styleUrls: ['./gdpr-panel.component.scss'],
    imports: [
    RouterLink,
    MatRipple,
    TranslatePipe
],
})
export class GdprPanelComponent implements OnInit {
    shouldBeShown = false;
    private localStorageKey = 'acceptUsingCookies';

    accept() {
        localStorage.setItem(this.localStorageKey, 'true');
        this.shouldBeShown = false;
    }

    ngOnInit(): void {
        if (!localStorage.getItem(this.localStorageKey)) {
            this.shouldBeShown = true;
        }
    }
}
